import gql from 'graphql-tag'

export const PRODUCT_MAIN_VARIANT_BASE_FRAGMENT = gql`
  fragment mainVariant on ProductVariant {
    id
    productAmount
    brief
    price
    title
    hasSale
    labels
    mediaIds
    variantUrl
    isAvailable
    gift
    hasSale
    inPromotion
    originalSalePrice
    discountPromotionSalePrice
    rrpSavePercent
    discountPrice
    discountPromotionPrice
    defaultActualPrice
    promotionPrice
    promotionEnd
    pricePerUnit {
      value
      measure
    }
    priceType
    priceRrp
    freeDelivery
    specialMedia {
      mediaId
      mimeType
      title
    }
    brand {
      title
      url
      mediaId
    }
    availability {
      key
      status
      countMall
      countOutlets
      countSupplier
      countExternal
      countShowrooms
      isAvailable
    }
  }
`
